<nav class="bg-primary-900">
  <div class="app__container">
    <div class="relative flex h-16 items-center justify-between text-white">
      <div>Cotizar {{ quoterState().risk.name }}</div>
      <div class="flex gap-5">
        @if (quoterState().quote.id) {
        <activar-button
          text="Descargar"
          fill="out"
          color="primary"
          (click)="downloadQuoteProposal()"
          [loading]="quoterState().downloadProposalLoading"
          loadingText="Descargando..."
        />
        }

       
        <activar-button
          text="Cancelar"
          fill="solid"
          color="danger"
          (click)="openModal()"
        />
      </div>
    </div>
  </div>
</nav>

@if(quoterState().agent && quoterState().agent.id){
			<app-selected-agent [user]="quoterState().agent" (clearUser)="openModal()"/>
		}
<div class="app__container pb-20">
  <router-outlet />
  <activar-chat-button *showForChannels="['direct']"/>
</div>

<activar-modal [(visible)]="quoterState().isLeavingModal">
  <div class="flex-col mx-auto p-5 text-center" style="width: 400px">
    <h2>Estas por cerrar el cotizador</h2>
    <p>Se perderan todos los datos.</p>

    <div class="flex mt-7 items-center justify-center gap-5">
      <activar-button
        text="Cancelar"
        fill="out"
        expand="full"
        color="primary"
        (click)="closeModal()"
      />
      <activar-button
        text="Cerrar cotizador"
        fill="solid"
        expand="full"
        color="danger"
        (click)="closeQuoter()"
      />
    </div>
  </div>
</activar-modal>

